import { SET_FLOW_GROUP_BPMN_STATE } from '../../actions'
import { Logger, LoggerTypes } from '../../utils'

export const flowGroupBpmnState = (state = {}, action) => {
  switch (action.type) {
    // -- SET_FLOW_GROUP_BPMN_STATE
    case SET_FLOW_GROUP_BPMN_STATE: {
      const isDirty = action?.data?.isDirty || null

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] flowGroupBpmnState.SET_FLOW_GROUP_BPMN_STATE()', {
        state,
        action,
        isDirty
      })

      return {
        ...state,
        isDirty
      }
    }

    default:
      return state
  }
}
